<template>
  <q-dialog
      v-model="analyzerOpened"
      prevent-close
      title="Результаты проверки доменов"
      @ok="onOk"
      @cancel="onCancel"
      :cancel="true"
  >
    <div slot="body">
      <q-inner-loading :visible="loading">
        <q-spinner size="50px" color="primary"></q-spinner>
      </q-inner-loading>

      <div v-if="errorsExist && !loading">
        <p class="response">&#10060; Обнаружены следующие ошибки: </p>
        <ul>
          <li v-for="(messages, domain) in errors">
            {{ domain }}
            <ul>
              <li v-for="message in messages">
                {{ message }}
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <p v-if="!errorsExist && !loading" class="response">&#9989; Ошибки не обнаружены</p>
    </div>

    <template slot="buttons" slot-scope="props">
      <q-btn flat label="Отмена" @click="props.cancel"/>
      <q-btn flat :label="okButtonText" @click="props.ok"/>
    </template>
  </q-dialog>
</template>

<script>

import {
  QDialog,
  QSpinner,
  QInnerLoading,
  QBtn,
} from 'quasar';

export default {
  name: "AnalyzeDomain",

  props: {
    opened: {
      type: Boolean,
      default: false,
    },

    project: {
      type: Object,
      required: true,
    },

    additionalDomain: {
      type: String,
      default: null,
    }
  },

  components: {
    QDialog,
    QSpinner,
    QInnerLoading,
    QBtn,
  },

  data() {
    return {
      loading: false,
      analyzerOpened: false,
      errors: {},
    }
  },

  methods: {
    onOk() {
      this.$emit('process');
    },

    onCancel() {
      this.$emit('closed');
    },
  },

  mounted() {
    this.analyzerOpened = this.opened;
    this.loading = true;

    this.$http.get(`api/v1.0/projects/${this.project.id}/analyze-domains`, {
      params: {
        additionalDomain: this.additionalDomain,
      }
    })
        .then(response => {
          const errors = response.data[0];
          console.log(response.data);

          this.errors = errors;

          this.loading = false;
        }).catch(error => {
          console.error(error)
          this.loading = false;
        });
  },

  computed: {
    errorsExist() {
      return Object.keys(this.errors).length !== 0;
    },

    okButtonText() {
      return this.additionalDomain ? 'Подключить домен' : 'Подключить ssl';
    },
  }
}
</script>

<style scoped>
.response {
  text-align: center;
  color: black;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectDomains/AnalyzeDomain.vue